import React from 'react';
import PropTypes from 'prop-types';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import FieldSet from '../../../../fieldset/FieldSet';

const NcDmvHearingFeeDetails = ({ selectedHearingFee, }) => {
  return (
    <>
      <FieldSet title="Hearing Fee">
        <VerticalLabelList items={VerticalLabelList.toList({
          Id: selectedHearingFee.id,
          'Customer ID': selectedHearingFee.customerId,
          'External Account Id': selectedHearingFee.externalAccountId,
          'External Bill Id': selectedHearingFee.externalBillId,
          'Hearing Description': selectedHearingFee.clientData_hearingDescription,
          'Hearing Fee Code': selectedHearingFee.clientData_hearingCode,
          'Hearing Post Pay Indicator': selectedHearingFee.clientData_postPayHearingInd,
          'Original Bill Balance': selectedHearingFee.originalBillBalance_value,
          'Client Reconciled Timestamp': selectedHearingFee.clientReconciledTimestamp,
        })}
        />
      </FieldSet>

      <FieldSet title="Transaction">
        <VerticalLabelList items={VerticalLabelList.toList({
          Id: selectedHearingFee.id,
          'Payment Transaction ID': selectedHearingFee.paymentTransactionId,
          'Payment Transaction Line Item ID': selectedHearingFee.paymentTransactionLineItemId,
          'Payment Amount': selectedHearingFee.paymentAmount,
          'Payment Date': selectedHearingFee.paymentDate,
        })}
        />
      </FieldSet>
    </>
  );
};

export default NcDmvHearingFeeDetails;

NcDmvHearingFeeDetails.propTypes = {
  selectedHearingFee: PropTypes.instanceOf(Object).isRequired,
};
